import React, { useEffect, useState } from 'react';
import {
  Table, Thead, Tbody, Tr, Th, Td, Button,
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter,
  useDisclosure, Flex, IconButton, Badge,
  Box
} from '@chakra-ui/react';
import { AddIcon } from '@chakra-ui/icons';
import SolicitudConstancia from '../Ventanas/SolicitudConstancia';

const TablaSolicitudConstancia: React.FC = () => {
  const [data, setData] = useState<any[]>([]);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [modo, setModo] = useState<'view' | 'edit' | 'new'>('view');
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/obras/solicitud-constancia`)
      .then(res => res.json())
      .then(setData)
      .catch(console.error);
  }, []);

  const openModal = (item: any, tipo: 'view' | 'edit') => {
    setSelectedItem(item);
    setModo(tipo);
    onOpen();
  };

  const openNuevo = () => {
    setSelectedItem(null);
    setModo('new');
    onOpen();
  };

  return (
    <Box overflowX="auto" borderRadius="md" boxShadow="md" bg="white" p={4}>
    <Table variant="simple" size="sm">
      <Thead bg="#5b182b">
          <Tr>
            <Th color="white">ID</Th>
            <Th color="white">Tipo</Th>
            <Th color="white">Responsable</Th>
            <Th color="white">Dirección</Th>
            <Th color="white">Costo</Th>
            <Th color="white">Acciones</Th>
          </Tr>
        </Thead>
        <Tbody>
          {data.map((item) => (
            <Tr key={item.id}>
              <Td>{item.id}</Td>
              <Td>{item.tipo}</Td>
              <Td>{item.responsable}</Td>
              <Td>{item.direccion}</Td>
              <Td>${item.costo}</Td>
              <Td>
                <Button size="xs" onClick={() => openModal(item, 'view')}>Ver</Button>{' '}
                <Button size="xs" onClick={() => openModal(item, 'edit')}>Editar</Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      <Flex mt={4} justify="center">
        <IconButton
          icon={<AddIcon />}
          aria-label="Agregar nuevo"
          colorScheme="green"
          borderRadius="full"
          size="lg"
          position="fixed"
          bottom="20px"
          right="20px"
           zIndex={10} 
          onClick={openNuevo}
        />
      </Flex>

      <Modal isOpen={isOpen} onClose={onClose} size="6xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {modo === 'view' && 'Ver Solicitud de Constancia'}
            {modo === 'edit' && 'Editar Solicitud de Constancia'}
            {modo === 'new' && 'Nueva Solicitud de Constancia'}
          </ModalHeader>
          <ModalBody>
            <SolicitudConstancia modo={modo} data={selectedItem} onSubmit={() => { onClose(); window.location.reload(); }} />
          </ModalBody>
          <ModalFooter>
            <Button onClick={onClose}>Cerrar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default TablaSolicitudConstancia;